import { Action } from '@ngrx/store';

import { Section } from '®shared/reading-list';

export enum SectionResolverStoreActionTypes {
  DRAFT_SECTION_REQUESTED = '[Section Resolver Store] Draft section requested',
  DRAFT_SECTION_LOADED = '[Section Resolver Store] Draft section loaded',
  DRAFT_SECTION_LOADING_FAILED = '[Section Resolver Store] Draft section loading failed',
  PUBLISHED_SECTION_REQUESTED = '[Section Resolver Store] Published section requested',
  PUBLISHED_SECTION_LOADED = '[Section Resolver Store] Published section loaded',
  PUBLISHED_SECTION_LOADING_FAILED = '[Section Resolver Store] Published section loading failed',
}

export interface SectionIdPayload {
  sectionId: string;
}

export class DraftSectionRequestedAction implements Action {
  readonly type = SectionResolverStoreActionTypes.DRAFT_SECTION_REQUESTED;

  constructor(public payload: SectionIdPayload) {}
}

export interface SectionLoadedPayload extends SectionIdPayload {
  section: Section;
}

export class DraftSectionLoadedAction implements Action {
  readonly type = SectionResolverStoreActionTypes.DRAFT_SECTION_LOADED;

  constructor(public payload: SectionLoadedPayload) {}
}

export interface SectionLoadingFailedPayload extends SectionIdPayload {
  error: any;
}

export class DraftSectionLoadingFailedAction implements Action {
  readonly type = SectionResolverStoreActionTypes.DRAFT_SECTION_LOADING_FAILED;

  constructor(public payload: SectionLoadingFailedPayload) {}
}

export class PublishedSectionRequestedAction implements Action {
  readonly type = SectionResolverStoreActionTypes.PUBLISHED_SECTION_REQUESTED;

  constructor(public payload: SectionIdPayload) {}
}

export class PublishedSectionLoadedAction implements Action {
  readonly type = SectionResolverStoreActionTypes.PUBLISHED_SECTION_LOADED;

  constructor(public payload: SectionLoadedPayload) {}
}

export class PublishedSectionLoadingFailedAction implements Action {
  readonly type =
    SectionResolverStoreActionTypes.PUBLISHED_SECTION_LOADING_FAILED;

  constructor(public payload: SectionLoadingFailedPayload) {}
}

export type SectionResolverStoreActions =
  | DraftSectionRequestedAction
  | DraftSectionLoadedAction
  | DraftSectionLoadingFailedAction
  | PublishedSectionRequestedAction
  | PublishedSectionLoadedAction
  | PublishedSectionLoadingFailedAction;
